import React from 'react';

/** Markdown illustration — `#` glyph + heading bar + body text lines. */
const MarkdownPage = () => (
  <div className="ill-mdpage" aria-hidden="true">
    <div className="ill-md-heading">
      <span className="ill-md-hash">#</span>
      <span className="ill-md-headbar"></span>
    </div>
    <span className="ill-md-bar"></span>
    <span className="ill-md-bar ill-md-bar-short"></span>
    <span className="ill-md-bar"></span>
    <span className="ill-md-bar ill-md-bar-short"></span>
  </div>
);

export default MarkdownPage;
